<template>
  <div>
    <div
      :class="oneTab ? 'one-tab' : 'mb-1 mt-n1'"
      class="v-tabs v-tabs--grow theme--dark mb-1 mt-n1"
    >
      <div
        :style="'height: ' + (oneTab ? 0 : 42) + 'px'"
        class="v-item-group theme--dark v-slide-group v-tabs-bar v-tabs-bar--is-mobile primary--text"
      >
        <div class="v-slide-group__wrapper">
          <div class="v-slide-group__content v-tabs-bar__content">
            <div
              v-for="(header, i) in headers"
              :key="header"
              :name="header"
              class="v-tab"
              :class="{'v-tab--active': i === value}"
              @click="$emit('input', i)"
            >
              <v-icon v-if="header === 'settings'">
                {{ IconEnum.settings }}
              </v-icon>
              <img
                v-else-if="header === 'ecocup'"
                :src="LogoImages.ecocup"
                alt="ecocup"
                width="24"
                height="24"
              >
              <span v-else>
                {{ header }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <template v-for="(header, i) in headers">
      <slot
        v-if="value === i"
        :name="`tab_${i}`"
      />
    </template>
  </div>
</template>

<script>
import { IconEnum } from '@/modules/Enums'
import { LogoImages } from '@/modules/Images'

export default {
  name: 'Tabs',

  props: {
    value: { type: Number, default: 0 },
    headers: { type: Array, default: () => [] }
  },

  data () {
    return {
      IconEnum,
      LogoImages
    }
  },

  computed: {
    oneTab () {
      return this.headers.length <= 1 && this.headers[0] !== 'ecocup'
    }
  }
}
</script>

<style scoped>
.v-tab--active {
  border-bottom: 2px solid white;
}
.v-tabs {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  width: 100%;
}
.v-slide-group {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.v-item-group {
  -webkit-box-flex: 0;
  -ms-flex: 0 1 auto;
  flex: 0 1 auto;
  position: relative;
  max-width: 100%;
  -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
.v-slide-group__wrapper {
  contain: content;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  overflow: auto;
}
.v-slide-group__content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex: 1 0 auto;
  flex: 1 0 auto;
  position: relative;
  -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  white-space: nowrap;
}
.v-tabs--grow > .v-tabs-bar .v-tab {
  -webkit-box-flex: 1;
  -ms-flex: 1 0 auto;
  flex: 1 0 auto;
  max-width: none;
}
.v-tab {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  cursor: pointer;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 0;
  -ms-flex: 0 1 auto;
  flex: 0 1 auto;
  font-size: 0.875rem;
  font-weight: 500;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  letter-spacing: 0.0892857143em;
  line-height: normal;
  min-width: 90px;
  max-width: 360px;
  outline: none;
  padding: 0 16px;
  position: relative;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  -webkit-transition: none;
  transition: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>
